module.exports = __webpack_public_path__ + "images/emoji/dromedary_camel.b425f6357bbdba7e5187.png";